module.exports = __webpack_public_path__ + "img/sy_15.17568ace.png";